import { TeachingTool } from './teaching-tool';
import { ParentEducationMoment } from './parent-education-moment';
import { Video } from './video';
import { Training } from './training';
import { Collection } from './collection';
import { ClassType } from './class-type';
import { Type } from 'class-transformer';
import { Callout } from './callout';

export class Resources {
    @Type(() => TeachingTool)
    teachingTools: TeachingTool[]
    @Type(() => ParentEducationMoment)
    parentEducationMoments: ParentEducationMoment[]
    @Type(() => Video)
    videos: Video[]
    @Type(() => Training)
    trainings: Training[]
    @Type(() => Collection)
    collections: Collection[]
    @Type(() => ClassType)
    classTypes: ClassType[]
    @Type(() => Callout)
    callouts: Callout[]

    lastSync: number

    static defaults(): Resources {
        const defaults = new Resources()
        defaults.teachingTools = []
        defaults.parentEducationMoments = []
        defaults.videos = []
        defaults.trainings = []
        defaults.collections = []
        defaults.classTypes = []
        defaults.callouts = []
        defaults.lastSync = 0
        return defaults
    }

    findCallout(slug: string): Callout {
        return this.callouts.find((callout: Callout) => callout?.slug?.toLowerCase() == slug.toLowerCase());
    }

    findCollection(uuid: string): Collection {
        return this.collections.find((collection: Collection) => uuid && (collection.uuid === uuid))
    }

    indexOfCollection(uuid: string): number {
        return this.collections.findIndex((collection: Collection) => uuid && (collection.uuid === uuid))
    }

    findPem(uuid: string): ParentEducationMoment {
        return this.parentEducationMoments.find((pem: ParentEducationMoment) => uuid && (pem.uuid === uuid) )
    }

    indexOfPem(uuid: string): number {
        return this.parentEducationMoments.findIndex((pem: ParentEducationMoment) => uuid && (pem.uuid === uuid) )
    }

}
